import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ToggleStatusDynamicPricingGroupResponseSchema } from "../response/ToggleStatusDynamicPricingGroupResponse";

interface ToggleStatusVariables {
    groupId: string;
    // Tipe status untuk menentukan endpoint mana yang akan dipanggil
    status: 'enable' | 'disable';
}

/**
 * Custom hook untuk mengubah status aktif (enable/disable) dari Dynamic Pricing Group.
 */
export const useToggleStatusDynamicPricingGroup = () => {
    return useMutation({
        mutationFn: async ({ groupId, status }: ToggleStatusVariables) => {
            try {
                // Endpoint akan dinamis berdasarkan status yang dikirim
                const response = await privateApi.post(`/v4/dynamic-pricing/group/${groupId}/${status}`);
                return response.data;
            } catch (error) {
                console.error(`Failed to ${status} group with ID ${groupId}:`, error);
                throw error;
            }
        },
        onSuccess: (responseData) => {
            const validationResult = ToggleStatusDynamicPricingGroupResponseSchema.safeParse(responseData);
            if (!validationResult.success) {
                throw new Error("Invalid data format received from server after changing status.");
            }
        },
    });
};